<ion-header>
  <ion-toolbar>
    <ion-title>{{ headerText }}</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="flex-column scroll-y">
  <ion-item lines="none" class="flex-noshrink">
    {{ instructionText }}
  </ion-item>

  <ejs-grid #grid [dataSource]="assistancesToRender$ | async" (rowSelected)="rowClicked($event)">
    <e-columns>
      <e-column field="id" headerText="ID" textAlign="Right" isPrimaryKey="true" [visible]="false"></e-column>
      <e-column field="plannedFrom" headerText="Čas začátku" width="5%">
        <ng-template #template let-data>
          {{ data.plannedFrom | date: 'dd.MM.yyyy HH:mm' }}
        </ng-template>
      </e-column>
      <e-column field="plannedTo" headerText="Čas konce" width="5%">
        <ng-template #template let-data>
          {{ data.plannedTo | date: 'dd.MM.yyyy HH:mm' }}
        </ng-template>
      </e-column>

      <e-column field="shortDescription" headerText="Krátký popis" width="15%"></e-column>

      <e-column field="statusId" headerText="Stav" width="5%">
        <ng-template #template let-data>
          <app-assistance-status [status]="data.status"></app-assistance-status>
        </ng-template>
      </e-column>

      <e-column field="actions" headerText="Akce" width="5%">
        <ng-template #template let-data>
          <ion-buttons id="btns-action">
            @if (data.lockedForChanges) {
              <div>
                <ion-spinner></ion-spinner>
              </div>
            } @else {
              <ion-button
                [disabled]="!Assistance.canBeBilled(data.realizedFrom, data.realizedTo, data.status)"
                (click)="buttonClicked(BTNS.bill)"
                [popper]="'Uzavřít'"
                [popperTrigger]="'hover'"
              >
                <ion-icon name="lock-closed-outline"></ion-icon>
              </ion-button>
              <ion-button
                [disabled]="!Assistance.canBeCanceled(data.realizedFrom, data.realizedTo, data.status)"
                (click)="buttonClicked(BTNS.cancel); console.log(data)"
                [popper]="'Zrušit'"
                [popperTrigger]="'hover'"
              >
                <ion-icon name="close-circle-outline"></ion-icon>
              </ion-button>
              <ion-button
                [disabled]="!Assistance.canBeDeleted(data)"
                (click)="buttonClicked(BTNS.delete)"
                [popper]="'Smazat'"
                [popperTrigger]="'hover'"
              >
                <ion-icon name="trash-outline"></ion-icon>
              </ion-button>
            }
          </ion-buttons>
        </ng-template>
      </e-column>
    </e-columns>
  </ejs-grid>
</div>
